// import { RootStore } from 'mobx-stores'
import { PaginationSearchBase, TriggerSearchFunc } from 'mobx-stores/utils'
import { Api } from 'services'
import {
  LegalStatuses,
  LegalTableSearchProps,
  LegalTableSortProps
} from './legal-table-store.types'
import {
  initialLegalTablePaginationProps,
  initialLegalTableSearchProps,
  legalTableNeedTimeoutSearchProps
} from './legal-table-store.utils'
import { LegalTableEntityDTO } from 'models/legal-table-entry'
import { LegalFilterDTO } from 'models/legal-filter'
import { SelectOption } from '@touche-lts/panel-ui/dist'

export class LegalTableStore extends PaginationSearchBase<
  LegalTableSortProps,
  LegalTableSearchProps,
  LegalTableEntityDTO
> {
  private legalApi: Api['legalApi']

  constructor (rootStore: any) {
    super({
      initialPaginationProps: initialLegalTablePaginationProps,
      initialSearchProps: initialLegalTableSearchProps,
      needTimeoutProps: legalTableNeedTimeoutSearchProps
    })
    this.legalApi = rootStore.generalStore.api.legalApi
  }

  // METHODS
  public triggerSearch: TriggerSearchFunc = async (options): Promise<void> => {
    const data = await this.legalApi.getlegalPages(this.storeFilter, {
      pageQueryParams: {
        page: options?.resetPageNumber ? 0 : this.pagination.page,
        size: this.pagination.size,
        sortDirection: this.pagination.sortDirection,
        sortProp: this.pagination.sortProp
      }
    })
    if (!data) return
    this.handleSearchResultPaginationProps(data)
    this.setSearchResults(data.content)
  }

  // COMPUTED
  private get storeFilter (): LegalFilterDTO {
    return {
      title: this.searchProps.title,
      status: !!this.searchProps.status ? this.searchProps.status : undefined,
      dateEnd: this.searchProps.createdDate
      ? this.searchProps.createdDate.start.toISOString()
      : null,
      dateStart: this.searchProps.createdDate
      ? this.searchProps.createdDate.end.toISOString()
      : null
    }
  }

  public get statusPublished(): SelectOption<LegalStatuses>[] {
    return Object.values(LegalStatuses).map(type => ({
      label: type,
      value: type
    })) 
  }
}
